@import '../../../../../static/less/variables';
@import '~bootstrap/less/mixins.less';

.btn-regular {
  height: 100%;
  background: #fff;
  color: @pipl-dark-gray;
  border: 1px solid #ddd;
  font-weight: 600;
  font-size: 15px;
  outline: 0;
  &:hover,
  &.active,
  &:focus,
  &:active {
    border-color: @pipl-blue;
    color: @pipl-blue;
    box-shadow: none;
    background: transparent;
    outline: 0;
  }
}

.o-main-app {
  p {
    margin-bottom: 9px;
  }

  h3 {
    margin-bottom: 20px;
    font-weight: 300;
  }
}

.s-sepearate-line {
  margin: 40px 0;
  border-top: 1px solid #eee;
}

.page-spinner {
  text-align: center;
  margin: auto;
  min-height: 300px;
  margin-top: 50px;
}

.c-list {
  margin-top: 45px;
  > li {
    &:first-child {
      padding-top: 0;
    }
    padding: 29px 0;
    font-size: 14px;
    color: #000;
    font-weight: 500;
    border-bottom: 1px solid #dae1ea;
    &:last-child {
      border-bottom: 0;
    }
  }
}

.s-header-part {
  .no-spacing,
  &.no-spacing {
    padding-right: 0;
    margin-right: 0;
  }
  .blue-text,
  &.blue-text {
    color: @pipl-blue;
  }
  h3 {
    font-weight: 300;
    color: @pipl-dark-gray;
    font-size: 32px;
    margin-bottom: 0;
  }
  .title-header {
    display: inline-block;
    vertical-align: bottom;
  }
  .switch-wrapper {
    float: right;
    line-height: 73px;
  }
  .switch-text {
    font-size: 15px;
    padding-right: 10px;
    font-weight: 600;
    vertical-align: middle;
  }
  font-weight: 300;
  color: @pipl-dark-gray;
  padding-bottom: 20px;
  margin-bottom: 30px;
  border-bottom: 1px solid @input-border-color;
  font-size: 32px;
  margin-right: -30px;
  padding-right: 30px;
}

.switch-wrapper {
  display: inline-block;
}

.c-sidebar {
  padding: 0;
  margin: 0 0 0 -12px;
  list-style: none;
  .ch-link {
    margin-bottom: 25px;
    a {
      &:hover {
        text-decoration: none;
      }
      &.active,
      &:hover {
        padding-left: 9px;
        border-left: 3px solid @link-color;
        color: @link-color;
      }
      padding-left: 12px;
      font-weight: 600;
      color: #000;
      text-transform: uppercase;
    }
    .ch-subs {
      padding: 0;
      list-style: none;
      margin: 0;
      .ch-sublink {
        margin: 15px 0;
        a {
          &.active,
          &:hover {
            padding-left: 18px;
            border-left-width: 2px;
            color: @link-color;
          }
          text-transform: capitalize;
          padding-left: 20px;
          color: @pipl-light-gray;
        }
      }
    }
  }
}

.t-blue-icon {
  .icon-bar {
    background-color: @pipl-blue;
  }
}

.o-subtext {
  color: @pipl-dark-gray;
  p {
    margin: 10px 0;
  }
}

.dark-gray {
  color: @pipl-dark-gray;
}

.o-buttons {
  .btn-blue + .btn-blue {
    margin-left: 10px;
  }

  .btn-blue + .btn-inverted {
    margin-left: 10px;
  }

  .btn-inverted + .btn-inverted {
    margin-left: 10px;
  }
}

@media screen and (max-width: @screen-sm-max) {
  .o-main-app {
    margin-bottom: 25px;
    min-height: 600px;
  }

  .s-header-part {
    font-size: 40px;
    margin-bottom: 10px;
    border: 0;
    margin-right: 0;
    padding-right: 0;
  }

  .c-sidebar {
    margin-left: 0;
  }

  .c-sidebar-icon {
    margin-left: -15px;
    margin-right: 5px;
    margin-top: 22px;
  }

  #js-side-bar {
    position: absolute;
    display: none;
    border-right: 1px solid @pipl-light-gray;
    padding-left: 0;
    height: 360px;
    &.collapse.in {
      display: block;
    }
  }

  .Select.Select--single {
    margin-bottom: 10px;
  }

  .management-menu-open {
    margin-left: 270px;
  }

  .sideIcon {
    margin-left: -15px;
    margin-right: 5px;
    margin-top: 22px;
  }
}

@media screen and (max-width: @screen-sm-min) {
  .o-buttons {
    margin-top: 40px;
    .btn-blue + .btn-blue {
      margin-left: 0;
    }

    .btn-blue + .btn-inverted {
      margin-left: 0;
    }

    .btn-inverted + .btn-inverted {
      margin-left: 0;
    }

    .btn {
      margin-bottom: 10px;
      display: block;
    }
  }
}



// WEBPACK FOOTER //
// webpack:///sef/pro/assets/routes/ManagementPanel/components/ManagementPanel.less